var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 40,
    viewBox: "0 0 63 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8057 11.1095V11.1076L36.9135 18.959L44.7239 15.6713C46.3113 14.9856 48.0227 14.6329 49.7519 14.6352C50.0407 14.6352 50.3256 14.6489 50.6085 14.6665C49.6698 11.0047 47.6876 7.6944 44.9029 5.13802C42.1182 2.58164 38.6508 0.88925 34.9223 0.266551C31.1937 -0.356147 27.3646 0.117668 23.9003 1.6304C20.436 3.14314 17.4857 5.62964 15.4081 8.78769L15.6071 8.78183C18.5035 8.77804 21.3434 9.5843 23.8057 11.1095Z",
    fill: "#0364B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8077 11.1076C21.3445 9.58274 18.504 8.77714 15.6071 8.78188L15.408 8.78774C12.5731 8.8232 9.80131 9.63044 7.3906 11.1227C4.9799 12.615 3.02135 14.7359 1.7254 17.2576C0.429445 19.7793 -0.154932 22.6065 0.0350525 25.4353C0.225037 28.2641 1.1822 30.9878 2.80371 33.3135L14.3583 28.4493L19.4976 26.2875L30.9371 21.4721L36.9115 18.959L23.8077 11.1076Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6085 14.6664C50.3234 14.6464 50.0377 14.636 49.7519 14.6351C48.0232 14.6337 46.3126 14.987 44.7258 15.6731L36.9135 18.9589L39.1787 20.3149L46.6028 24.7615L49.8417 26.701L60.9183 33.3348C61.9247 31.4666 62.4463 29.3757 62.4352 27.2537C62.4242 25.1317 61.8808 23.0463 60.8549 21.1887C59.8291 19.3311 58.3535 17.7606 56.5633 16.6211C54.7732 15.4816 52.7257 14.8095 50.6085 14.6664Z",
    fill: "#1490DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8417 26.701L46.6028 24.7616L39.1787 20.313L36.9154 18.9589L30.9391 21.472L19.4996 26.2874L14.3583 28.4492L2.7998 33.3134C4.23647 35.3788 6.15173 37.0657 8.38197 38.2301C10.6122 39.3945 13.0912 40.0017 15.6071 39.9999H49.7519C52.0415 40.0008 54.2887 39.3816 56.2547 38.2081C58.2207 37.0346 59.8323 35.3506 60.9183 33.3349L49.8417 26.701Z",
    fill: "#28A8EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDriveIcon);
export default __webpack_public_path__ + "static/media/one-drive-icon.fb4955a194b96c0da97664f571d346fb.svg";
export { ForwardRef as ReactComponent };